import * as React from 'react'

import { styled } from '~/styled'
import { cn } from '~/styled'

const GridContainer = styled(
  'div',
  {
    base: ['grid'],
    variants: {
      gap: {
        0: ['gap-0.5'],
        1: ['gap-1'],
        2: ['gap-2'],
        3: ['gap-3'],
        4: ['gap-4'],
        24: ['gap-6'],
        5: ['gap-8'],
        6: ['gap-10'],
        7: ['gap-12'],
        8: ['gap-16'],
        9: ['gap-20']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

type GridProps = React.ComponentProps<typeof GridContainer> & {
  minItemSize?: string
  maxItemSize?: string
}

export const Grid = ({
  className,
  style,
  gap = '2',
  minItemSize,
  maxItemSize = '1fr',
  ...remainingProps
}: GridProps) => (
  <GridContainer
    {...remainingProps}
    style={{
      ...style,
      ...(minItemSize && { '--min-item-size': minItemSize }),
      ...(maxItemSize && { '--max-item-size': maxItemSize })
    }}
    gap={gap}
    className={cn(
      minItemSize && [
        'grid-cols-[repeat(auto-fit,minmax(var(--min-item-size,0),var(--max-item-size,0)))]'
      ],
      className
    )}
  />
)

Grid.displayName = 'Grid'
